(function ($) {

    $(function () {

        var $undergradResultsTable = $("#career-results-undergrad");
        var $gradResultsTable = $("#career-results-grad");

        // Update the visual presentation of rows in the results table.
        var updateResultsTableRows = function($resultsTable)
        {

            var $rows = $resultsTable.find("tbody tr");
            var $visibleRows = $rows.filter(":visible");
            var $noResults = $resultsTable.siblings(".no-results");
            var activeClass = "active";
            var highlightClass = "highlight";

            // Remove active and highlight classes from all rows.
            $rows.removeClass(activeClass + " " + highlightClass);

            // Reassign active class to visible rows and highlight class to even-numbered visible rows.
            $visibleRows.each(function (index, item)
                {

                    $item = $(item);

                    $item.addClass(activeClass);

                    if (index % 2 == 0)
                    {
                        $item.addClass(highlightClass);
                    }

                }
            );

            // If there are no results, show the no-results panel; otherwise if there are results, hide the panel.
            if ($visibleRows.length == 0)
            {
                $noResults.show();
            }
            else
            {
                $noResults.hide();
            }

        }

        var refreshResultsTables = function()
        {
            updateResultsTableRows($undergradResultsTable);
            updateResultsTableRows($gradResultsTable);
        }

        var bindDynamicFilters = function(filterSelector, dataAttributeSelector, filteredClass, $table, programURLs, $programLinkDiv, programNames)
        {
            var $filter = $(filterSelector);
            $filter.on(
                "change",
                function ()
                {

                    var $allRows = $table.find("tbody tr");
                    var selectedValue = $filter.val();
                    var $visibleRows = $allRows.not(".footable-filtered, .no-results");
                    var selectedIndex = parseInt(selectedValue);

                    if (selectedValue != "")
                    {
                        $programLinkDiv.empty().append("<a href=\"" + programURLs[selectedIndex] + "\">View " + programNames[selectedIndex] + " Page</a>");
                    }
                    else
                    {
                        $programLinkDiv.empty();
                    }

                    // If the user has selected a filter ...
                    if (selectedValue != "")
                    {

                        // Process the visible rows.
                        $visibleRows.each(function (index, item) {
                            var $item = $(item);
                            var itemDataAttribute = $item.attr(dataAttributeSelector);

                            // Add class that will be removed if found to be in results.
                            $item.addClass(filteredClass);

                            // Compare data on item to what is toggled in filters.
                            $.each(
                                itemDataAttribute.split(","),
                                function (index, value)
                                {
                                    if (value == selectedValue)
                                    {
                                        $item.removeClass(filteredClass);
                                        return false;
                                    }
                                }
                            );
                        });

                    }
                    else
                    {
                        $allRows.addClass(filteredClass);
                    }
                    refreshResultsTables();

                    // Note: This is here in order to work around a problem with the sticky left nav.
                    $(window).trigger("resize");
                    window.setTimeout(function () {
                        $(window).trigger("resize");
                    }, 500);

                }
            );
            $filter.trigger("change");
        }

        var $window = $(window);

        // Ensure major dropdowns filters are reset on page load.
        $("#career-filter-major-undergrad").val("");
        $("#career-filter-major-grad").val("");

        // Set up footable plugin on results tables.
        $undergradResultsTable.footable(
            {
                "breakpoints":
                {
                    "tablet": 750
                },
                "filter":
                {
                    "minimum": 1
                }
            }
        ).bind(
            {
                "footable_filtered": function ()
                {
                    updateResultsTableRows($undergradResultsTable);
                    $("#career-filter-major-undergrad").trigger("change");
                }
            }
        );
        $gradResultsTable.footable(
            {
                "breakpoints":
                {
                    "tablet": 750
                },
                "filter":
                {
                    "minimum": 1 
                }
            }
        ).bind(
            {
                "footable_filtered": function ()
                {
                    updateResultsTableRows($gradResultsTable);
                    $("#career-filter-major-grad").trigger("change");
                }
            }
        );

        // Create "no results" panels.
        $("<div class=\"no-results\">No results found.</div>").insertAfter($undergradResultsTable).hide();
        $("<div class=\"no-results\">No results found.</div>").insertAfter($gradResultsTable).hide();

        // Reset the results tables.
        //refreshResultsTables(true);

        // Bind the dynamic filter dropdowns to filtering the results.
        if (
            window.UGProgramURLs != undefined &&
            window.VLSProgramURLs != undefined
        ) {
            bindDynamicFilters("#career-filter-major-undergrad", "data-programs", "filtered-major", $("#career-results-undergrad"), UGProgramURLs, $("#ug-program-page-link"), window.UGProgramNames);
            bindDynamicFilters("#career-filter-major-grad", "data-programs", "filtered-major", $("#career-results-grad"), VLSProgramURLs, $("#vls-program-page-link"), window.VLSProgramNames);
        }

        // Set up custom select boxes.
        $('.career-filter select').selectric(
            {
                responsive: true,
                arrowButtonMarkup: "<span class='button'></span>",
                disableOnMobile: true
            }
        );

        // Set up submission click events.
        $("#career-filter-submit, #career-filter .search-button").on("click", function ()
            {
                scrollToEl("#career-results-undergrad");
            }
        );
        $("#career-filter-submit-grad, #career-filter-grad .search-button").on("click", function ()
            {
                scrollToEl("#career-results-grad");
            }
        );

        // Set up sorting click event.
        $("th.footable-sortable").on("click", function ()
            {
                refreshResultsTables();
            }
        );

        // Bind window resize and load handlers to refresh the results tables.
        $window.on("resize", $.throttle(25, true, function ()
            {
                refreshResultsTables();
            }
        ));
        $window.on("load", function ()
            {
                refreshResultsTables();
            }
        );

    });

}(jQuery));

var scrollToEl = function (el, spacing) {
    // set default spacing to 0
    var spacing = spacing || 20;

    if ($JQ(el).length) {
        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        if (viewportWidth >= 960) {
            // calculate height of "sticky" elements
            var extra = $JQ('#header').outerHeight(true);
        }
        else {
            extra = 0;
        }

        $JQ('html, body').animate({
            // 20 is extra spacing away from sticky nav
            scrollTop: $JQ(el).offset().top - extra - spacing
        }, 600)
    }
};